import { Circle, FeatureGroup, Marker, Popup, Rectangle, Polygon, TileLayer, useMap } from 'react-leaflet';

import useRasterCoords from './useRasterCoords';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './RasterMap.scss';
import { roomToCoordinate, zoneToRoomToPolygonCoord } from './roomCoordinates';
import { PatientVisit } from '../../amplify/api-gateway/search-patients';
import { useEffect, useMemo } from 'react';
import LabelLayer from './LabelLayer';

interface RasterMapProps {
    img: [width: number, height: number];
    url: string;
    patients: PatientVisit[];
    selectedZone: string;
    modelPredictions: any[];
    mapHighlightType: string;
    setInternalCSN: (internalCSN?: string) => void;
    setSelectedRoom: (room: string) => void;
}

const RasterMap = ({
    img, 
    url,
    patients,
    selectedZone,
    modelPredictions,
    mapHighlightType,
    setInternalCSN,
    setSelectedRoom,
}: RasterMapProps) => {

    const map = useMap();
    const rc = useRasterCoords(img);

    useEffect(() => {
        // set the default view and zoom
        map.invalidateSize();
        map.setView(rc.unproject([img[0], img[1]]), 2);
        // @ts-ignore
        map.setMaxBounds([rc.unproject([-1000, -1000]), rc.unproject([img[0] + 1000, img[1] + 1000])])
        map.invalidateSize();
        // console.log("Raster Coords", rc.getMaxBounds());
    }, [selectedZone])

    return (
        <>
            <TileLayer url={url} noWrap={true} />
            <LabelLayer rc={rc} patients={patients} modelPredictions={modelPredictions} selectedZone={selectedZone} mapHighlightType={mapHighlightType} setInternalCSN={setInternalCSN} setSelectedRoom={setSelectedRoom} />
        </>
    );

};

export default RasterMap;
